import FlashTimer from './flash_timer.mjs'

export default class FlashMessage extends HTMLElement {
  connectedCallback () {
    const duration = Number(this.dataset.duration) || 5000
    const progress = this.querySelector('[data-flash-progress]')
    const progressbar = progress?.parentElement

    this.timer = new FlashTimer({
      duration,
      onProgress: (remaining) => {
        if (progress) progress.style.transform = `scaleX(${remaining})`
        progressbar?.setAttribute('aria-valuenow', String(Math.ceil(remaining * duration / 1000)))
      },
      onComplete: () => this.dismiss()
    })

    this.addEventListener('mouseenter', () => this.timer.pause())
    this.addEventListener('mouseleave', () => this.timer.resume())
    this.querySelector('[data-flash-close]')?.addEventListener('click', () => this.dismiss())
    this.timer.start()
  }

  disconnectedCallback () {
    this.timer?.stop()
  }

  dismiss () {
    if (this.dismissed) return

    this.dismissed = true
    this.timer?.stop()
    this.classList.add('opacity-0', '-translate-y-2')

    // Keep the #flash container so later turbo-stream toasts still have a target.
    window.setTimeout(() => this.remove(), 150)
  }
}
